import PaymentMethodDelPopup from './PaymentMethodDelPopup'

export default PaymentMethodDelPopup
